import useResource from 'app/hooks/useResource';

import {
  getMarketing,
  setMarketingParams
} from 'app/actions/marketing';

import {
  createMarketing,
  updateMarketing,
  deleteMarketing,
} from 'app/services/marketing';

import {
  marketing as resource
} from 'app/resources';

const useMarketing = () => {
  return useResource({
    resource,
    getResource: getMarketing,
    createResource: createMarketing,
    updateResource: updateMarketing,
    destroyResource: deleteMarketing,
    setResourceParams: setMarketingParams
  });
}

export default useMarketing;
